import { render, staticRenderFns } from "./affiliateSheet.vue?vue&type=template&id=0905d60a&scoped=true"
import script from "./affiliateSheet.vue?vue&type=script&lang=js"
export * from "./affiliateSheet.vue?vue&type=script&lang=js"
import style0 from "./affiliateSheet.vue?vue&type=style&index=0&id=0905d60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905d60a",
  null
  
)

export default component.exports